import React from "react"
import PropTypes from "prop-types"
import capitalize from "lodash.capitalize"
import { InfoCircleOutlined } from "@ant-design/icons"
import { Tag, Space, Tooltip } from "antd"

import { TRANSACTION_STATUS } from "@components/Domain"

const getStatusColor = status => {
  return {
    [TRANSACTION_STATUS.HOLD]: "orange",
    [TRANSACTION_STATUS.ERROR]: "red",
    [TRANSACTION_STATUS.FAILED]: "red",
    [TRANSACTION_STATUS.PENDING]: "blue",
    [TRANSACTION_STATUS.REJECTED]: "red",
    [TRANSACTION_STATUS.PROCESSED]: "green",
    [TRANSACTION_STATUS.PENDING_APPROVAL]: "orange",
  }[status]
}


const InvestorTransactionStatusTag = ({
  value = undefined,
  holdReason = undefined,
  hasChangedReceiverSource = false,
  status,
}) => {
  const color = getStatusColor(status)

  let title = value
    ? value
    : capitalize(status)

  const isHold = status === TRANSACTION_STATUS.HOLD
  const isQueued = isHold && hasChangedReceiverSource

  if (isQueued) {
    title = "Queued"
  }

  return (
    <Tag
      color={color}
      bordered={false}
    >
      <Space>
        {title}

        {
          isHold && !isQueued && (
            <Tooltip title={holdReason}>
              <InfoCircleOutlined />
            </Tooltip>
          )
        }
      </Space>
    </Tag>
  )
}

InvestorTransactionStatusTag.propTypes = {
  value: PropTypes.node,
  status: PropTypes.string.isRequired,
  holdReason: PropTypes.string,
  hasChangedReceiverSource: PropTypes.bool,
}

export default InvestorTransactionStatusTag
